import flowBuilderReducer from '@/features/admin-geral/store/flowBuilder/reducers';
import negotiationAgentsReducer from '@/features/admin-geral/store/negotiationAgents/reducers';
import agentSettingsReducer from '@/features/admin-geral/store/agentSettings/reducers';
import { modelosDecursoReducer } from '@/features/secretaria-arbitral/store/modelosDecurso';
import { origemPedidoReducer } from '@/features/secretaria-arbitral/store/origemPedido/reducers';
import { type AnyAction, combineReducers, configureStore } from '@reduxjs/toolkit';

import advogadoReducer from '@/features/advogado/store';
import { advogadoAvulsoReducer } from '@/features/advogadoAvulso/store';
import { autosAdvogadoReducer, portalAdvogadoReducer } from '@/features/portal-advogado/store';
import { arbitralLoteReducer, arbitralReducer } from '@/features/arbitral/store';
import arbitroReducer from '@/features/arbitro/store';
import { arbitroNomeacoesReducer } from '@/features/arbitroNomeacoes/store';
import arbitrosReducer from '@/features/arbitros/store';
import { arbitrosAdminReducer } from '@/features/arbitrosAdmin/store';
import { situacoesArbitralReducer } from '@/features/situacoesArbitral';
import { assinaturaReducer } from '@/features/assinatura/store/slice';
import { authReducer } from '@/features/auth/store';
import categoriaReducer from '@/features/categoria/store';
import classeJudicialReducer from '@/features/classeJudicial/store/slice';
import { comarcaReducer } from '@/features/comarca/store';
import { cumprimentoReducer } from '@/features/cumprimento/store';
import { customFieldsReducer } from '@/features/customFields';
import { delegacaoReducer } from '@/features/delegacao/store';
import { documentosReducer } from '@/features/documentos/store';
import { documentosPadraoReducer } from '@/features/documentosPadrao/store';
import escritorioConvitesReducer from '@/features/escritorio/store/convites';
import escritorioCrudReducer from '@/features/escritorio/store/crud';
import escritorioMembrosReducer from '@/features/escritorio/store/membros';
import { preferenciasUiReducer } from '@/features/layout/store';
import permissoesDominioReducer from '@/features/escritorio/store/permissoesDominio/slice';
import { centralAtendimentosReducer } from '@/features/centralAtendimentos/store';
import { auditoriaReducer as chatAtendimentoAuditoriaReducer } from '@/features/chatAtendimento/store/auditoria';
import { conversationsReducer as chatAtendimentoConversationsReducer } from '@/features/chatAtendimento/store/conversations';
import { messagesReducer as chatAtendimentoMessagesReducer } from '@/features/chatAtendimento/store/messages';
import { pendenciasReducer as chatAtendimentoPendenciasReducer } from '@/features/chatAtendimento/store/pendencias';
import { processoInternoReducer as chatAtendimentoProcessoInternoReducer } from '@/features/chatAtendimento/store/processoInterno';
import { respostasRapidasReducer as chatAtendimentoRespostasRapidasReducer } from '@/features/chatAtendimento/store/respostasRapidas';
import { certificadoReducer } from '@/features/extrajudicial/certificado/store';
import extrajudicialReducer from '@/features/extrajudicial/store';
import { conversaoDaNotificacaoReducer } from '@/features/extrajudicial/store/conversao';
import { documentoNotificacaoReducer } from '@/features/extrajudicial/store/documentoNotificacao';
import { recipientReducer } from '@/features/extrajudicial/recipient/store';
import { templateReducer } from '@/features/extrajudicial/template/store';
import { reguaCobrancaReducer, reguaLoteBatchReducer } from '@/features/reguaCobranca/store';
import { adminTenantsReducer } from '@/features/admin-geral/store/tenants';
import { globalUsersReducer } from '@/features/admin-geral/store/globalUsers';
import { flowEditorTabsReducer } from '@/features/admin-geral/store/flowEditorTabs';
import { flowsReducer } from '@/features/admin-geral/store/flows';
import flowCustomGroupsReducer from '@/features/admin-geral/store/flowCustomGroups/slice';
import { adminLookupsReducer } from '@/features/admin-geral/store/lookups';
import { workspaceCredentialsReducer } from '@/features/admin-geral/store/workspaceCredentials';
import { secretariaPermissionsReducer } from '@/features/admin-geral/store/secretariaPermissions';
import { dashboardAtendimentoReducer } from '@/features/admin-geral/store/dashboardAtendimento';
import { dashboardLexiReducer } from '@/features/admin-geral/store/dashboardLexi';
import { porteiroAvaliacaoReducer } from '@/features/admin-geral/store/porteiroAvaliacao';
import { porteiroObservabilidadeReducer } from '@/features/admin-geral/store/porteiroObservabilidade';
import { arbitragensGlobaisReducer } from '@/features/admin-geral/store/arbitragensGlobais';
import { negociacoesGlobaisReducer } from '@/features/admin-geral/store/negociacoesGlobais';
import { avaliacoesGlobaisReducer } from '@/features/admin-geral/store/avaliacoes';
import { flowLogsReducer } from '@/features/admin-geral/store/flowLogs';
import { notificacoesGlobaisReducer } from '@/features/admin-geral/store/notificacoesGlobais';
import { notificacoesMetricasReducer } from '@/features/admin-geral/store/notificacoesMetricas';
import { qaReducer } from '@/features/admin-geral/store/qa';
import adminTemplatesReducer from '@/features/admin-geral/store/templates/slice';
import { homeReducer } from '@/features/home/store/slice';
import { homeConversasReducer } from '@/features/home-conversas/store';
import { contractsMiddleware } from '@/features/contracts/store/middleware';
import { homeConversasMiddleware } from '@/features/home-conversas/store/middleware';
import { portalReducer } from '@/features/portal/store';
import { citacaoArbitralReducer } from '@/features/portal-arbitral/store';
import { gruposAdminReducer } from '@/features/gruposAdmin/store';
import { iaReducer } from '@/features/ia/store';
import messagingReducer from '@/features/messaging/store/slice';
import { negociacaoDetailReducer } from '@/features/negociacaoDetalhes';
import { negociacaoFeedbackReducer } from '@/features/negociacaoFeedback';
import { negociacaoIndividualWizardReducer } from '@/features/negociacaoIndividualWizard';
import { negociacaoSelfReducer } from '@/features/negociacaoSelf';
import { negociacaoSimulacaoReducer } from '@/features/negociacaoSimulacao/store';
import { reportsReducer } from '@/features/negociacaoRelatorios/store/slice';
import { notificacaoSelfReducer } from '@/features/notificacaoSelf';
import { onboardingSelfReducer } from '@/features/onboardingSelf';
import { negociacaoColunasReducer } from '@/features/negociacaoColunas';
import { negociacoesReducer } from '@/features/negociacoes';
import { partesReducer } from '@/features/partes/store';
import processoPermissoesReducer from '@/features/peticionamento/store/processoPermissoes/slice';
import { peticionamentoReducer } from '@/features/peticionamento/store/slice';
import { processosReducer } from '@/features/processos/store';
import setorReducer from '@/features/setor/store';
import { compartilhamentoReducer } from '@/features/compartilhamento/store';
import tribunalReducer from '@/features/tribunal/store';
import usuarioReducer from '@/features/usuario/store';
import { usuarioPapelAdminReducer } from '@/features/usuarioPapelAdmin/store';
import appReducer from '@/store/appSlice';
import { posthogAnalyticsMiddleware } from '@/store/middleware/posthogAnalyticsMiddleware';
import { contextoAcessoReducer } from '@/features/contextoAcesso/store';
import { notificationBellReducer } from '@/features/notification-bell/store';
import { notificationPreferencesReducer } from '@/features/notification-preferences/store';
import { onboardingReducer } from '@/features/onboarding';
import { pendenciasReducer } from '@/features/pendencias/store';
import autenticacaoPublicaReducer from '@/features/autenticacaoPublica/store';
import { rascunhoStepReducer } from '@/features/processo-arbitral/store/rascunhoStep';
import { submissaoStepReducer } from '@/features/processo-arbitral/store/submissaoStep';
import { wizardStepReducer } from '@/features/processo-arbitral/store/wizardStep';
import { autorizacaoArReducer } from '@/features/arbitral-detalhes/store/autorizacaoAr/slice';
import { envioFisicoArReducer } from '@/features/arbitral-detalhes/store/envioFisicoAr/slice';
import { certificadosArbitraisReducer } from '@/features/arbitral-detalhes/store/certificados/slice';
import { certificadoAcessosSentencaReducer } from '@/features/encerramento-processo/store/certificado-sentenca/slice';
import { sentencaArbitralReducer } from '@/features/encerramento-processo/store/sentenca/slice';
import { arbitralDetalhesReducer } from '@/features/arbitral-detalhes/store';
import { baixarProcessoReducer } from '@/features/baixar-processo/store';
import { activeProductsReducer } from '@/features/admin-geral/store/activeProducts';
import { contratosTenantReducer } from '@/features/admin-geral/store/contratosTenant';
import { convitesTenantReducer } from '@/features/admin-geral/store/convitesTenant';
import { membrosTenantReducer } from '@/features/admin-geral/store/membrosTenant';
import portalFaqReducer from '@/features/admin-geral/store/portalFaq/slice';
import { plataformaStatusReducer } from '@/features/admin-geral/store/plataformaStatus';
import { plataformaEmbedUrlReducer } from '@/features/admin-geral/store/plataformaEmbedUrl';
import { plataformaLogsReducer } from '@/features/admin-geral/store/plataformaLogs';
import { saudeIntegracoesReducer } from '@/features/admin-geral/store/saudeIntegracoes';
import { contractsReducer, trialStatusReducer } from '@/features/contracts';
import { trialsReducer } from '@/features/trials';
import { apuracaoReducer } from '@/features/apuracao';
import { centralWebhooksReducer } from '@/features/centralWebhooks/store';
import { chavesDeApiReducer } from '@/features/chavesDeApi/store';
import { faturasReducer } from '@/features/faturas';
import { financeiroEscritorioReducer } from '@/features/financeiroEscritorio/store';
import { financeiroProcessoArbitralReducer } from '@/features/financeiroProcessoArbitral/store';
import {
  fluxoEditorReducer,
  fluxosArbitraisReducer,
} from '@/features/secretaria-arbitral/fluxos/store';
import {
  secretariaArbitralAuditoriaReducer,
  secretariaArbitralModelosCartaReducer,
  secretariaArbitralReducer,
  secretariaArbitralRegistroCitacaoReducer,
  secretariaArbitralRegistroIntimacaoSentencaReducer,
  secretariaArbitralTentarDeNovoReducer,
} from '@/features/secretaria-arbitral/store';
import modelosAndamentoReducer from '@/features/modelos-andamento/store';
import modelosCartaReducer from '@/features/modelos-carta/store';
import modelosComunicacaoReducer from '@/features/modelos-comunicacao/store';
import { modelosDocumentoReducer } from '@/features/modelos-documento/store';
import modelosNotificacaoReducer from '@/features/modelos-notificacao/store';
import { pesquisaSatisfacaoReducer } from '@/features/pesquisaSatisfacao/store/slice';
import tiposPrazoReducer from '@/features/tipos-prazo/store';

const appReducers = combineReducers({
  app: appReducer,
  auth: authReducer,
  home: homeReducer,
  homeConversas: homeConversasReducer,
  assinatura: assinaturaReducer,
  peticionamento: peticionamentoReducer,
  processoPermissoes: processoPermissoesReducer,
  processos: processosReducer,
  partes: partesReducer,
  documentos: documentosReducer,
  documentosPadrao: documentosPadraoReducer,
  escritorioMembros: escritorioMembrosReducer,
  preferenciasUi: preferenciasUiReducer,
  escritorioConvites: escritorioConvitesReducer,
  escritorioCrud: escritorioCrudReducer,
  permissoesDominio: permissoesDominioReducer,
  categoria: categoriaReducer,
  cumprimento: cumprimentoReducer,
  arbitros: arbitrosReducer,
  arbitro: arbitroReducer,
  setor: setorReducer,
  compartilhamento: compartilhamentoReducer,
  chatAtendimentoConversations: chatAtendimentoConversationsReducer,
  chatAtendimentoMessages: chatAtendimentoMessagesReducer,
  chatAtendimentoPendencias: chatAtendimentoPendenciasReducer,
  chatAtendimentoRespostasRapidas: chatAtendimentoRespostasRapidasReducer,
  chatAtendimentoAuditoria: chatAtendimentoAuditoriaReducer,
  chatAtendimentoProcessoInterno: chatAtendimentoProcessoInternoReducer,
  centralAtendimentos: centralAtendimentosReducer,
  tribunal: tribunalReducer,
  comarca: comarcaReducer,
  classeJudicial: classeJudicialReducer,
  advogado: advogadoReducer,
  advogadoAvulso: advogadoAvulsoReducer,
  portalAdvogado: portalAdvogadoReducer,
  advogadoAutos: autosAdvogadoReducer,
  usuario: usuarioReducer,
  delegacao: delegacaoReducer,
  extrajudicial: extrajudicialReducer,
  extrajudicialDocumentoNotificacao: documentoNotificacaoReducer,
  extrajudicialConversao: conversaoDaNotificacaoReducer,
  certificado: certificadoReducer,
  recipient: recipientReducer,
  template: templateReducer,
  reguaCobranca: reguaCobrancaReducer,
  reguaLoteBatch: reguaLoteBatchReducer,
  ia: iaReducer,
  adminTenants: adminTenantsReducer,
  globalUsers: globalUsersReducer,
  flows: flowsReducer,
  negotiationAgents: negotiationAgentsReducer,
  agentSettings: agentSettingsReducer,
  flowBuilder: flowBuilderReducer,
  flowEditorTabs: flowEditorTabsReducer,
  flowCustomGroups: flowCustomGroupsReducer,
  adminLookups: adminLookupsReducer,
  workspaceCredentials: workspaceCredentialsReducer,
  secretariaPermissions: secretariaPermissionsReducer,
  dashboardAtendimento: dashboardAtendimentoReducer,
  dashboardLexi: dashboardLexiReducer,
  porteiroObservabilidade: porteiroObservabilidadeReducer,
  porteiroAvaliacao: porteiroAvaliacaoReducer,
  arbitragensGlobais: arbitragensGlobaisReducer,
  negociacoesGlobais: negociacoesGlobaisReducer,
  avaliacoesGlobais: avaliacoesGlobaisReducer,
  flowLogs: flowLogsReducer,
  notificacoesGlobais: notificacoesGlobaisReducer,
  notificacoesMetricas: notificacoesMetricasReducer,
  qa: qaReducer,
  adminTemplates: adminTemplatesReducer,
  customFields: customFieldsReducer,
  arbitral: arbitralReducer,
  arbitralLote: arbitralLoteReducer,
  arbitroNomeacoes: arbitroNomeacoesReducer,
  arbitrosAdmin: arbitrosAdminReducer,
  situacoesArbitral: situacoesArbitralReducer,
  gruposAdmin: gruposAdminReducer,
  usuarioPapelAdmin: usuarioPapelAdminReducer,
  negociacoes: negociacoesReducer,
  negociacaoColunas: negociacaoColunasReducer,
  negociacaoDetail: negociacaoDetailReducer,
  negociacaoFeedback: negociacaoFeedbackReducer,
  messaging: messagingReducer,
  negociacaoIndividualWizard: negociacaoIndividualWizardReducer,
  negociacaoSelf: negociacaoSelfReducer,
  negociacaoSimulacao: negociacaoSimulacaoReducer,
  negociacaoRelatorios: reportsReducer,
  notificacaoSelf: notificacaoSelfReducer,
  onboardingSelf: onboardingSelfReducer,
  onboarding: onboardingReducer,
  portal: portalReducer,
  citacaoArbitral: citacaoArbitralReducer,
  pendencias: pendenciasReducer,
  contextoAcesso: contextoAcessoReducer,
  notificationBell: notificationBellReducer,
  notificationPreferences: notificationPreferencesReducer,
  autenticacaoPublica: autenticacaoPublicaReducer,
  processoArbitralRascunhoStep: rascunhoStepReducer,
  processoArbitralSubmissaoStep: submissaoStepReducer,
  processoArbitralWizardStep: wizardStepReducer,
  autorizacaoAr: autorizacaoArReducer,
  envioFisicoAr: envioFisicoArReducer,
  certificadosArbitrais: certificadosArbitraisReducer,
  certificadoAcessosSentenca: certificadoAcessosSentencaReducer,
  sentencaArbitral: sentencaArbitralReducer,
  arbitralDetalhes: arbitralDetalhesReducer,
  baixarProcesso: baixarProcessoReducer,
  activeProducts: activeProductsReducer,
  contratosTenant: contratosTenantReducer,
  convitesTenant: convitesTenantReducer,
  membrosTenant: membrosTenantReducer,
  portalFaq: portalFaqReducer,
  plataformaStatus: plataformaStatusReducer,
  plataformaEmbedUrl: plataformaEmbedUrlReducer,
  plataformaLogs: plataformaLogsReducer,
  saudeIntegracoes: saudeIntegracoesReducer,
  trials: trialsReducer,
  contracts: contractsReducer,
  contractsTrialStatus: trialStatusReducer,
  apuracao: apuracaoReducer,
  centralWebhooks: centralWebhooksReducer,
  chavesDeApi: chavesDeApiReducer,
  faturas: faturasReducer,
  financeiroEscritorio: financeiroEscritorioReducer,
  financeiroProcessoArbitral: financeiroProcessoArbitralReducer,
  secretariaArbitral: secretariaArbitralReducer,
  origemPedido: origemPedidoReducer,
  secretariaArbitralAuditoria: secretariaArbitralAuditoriaReducer,
  secretariaArbitralModelosCarta: secretariaArbitralModelosCartaReducer,
  secretariaArbitralRegistroCitacao: secretariaArbitralRegistroCitacaoReducer,
  secretariaArbitralRegistroIntimacaoSentenca: secretariaArbitralRegistroIntimacaoSentencaReducer,
  secretariaArbitralTentarDeNovo: secretariaArbitralTentarDeNovoReducer,
  fluxosArbitrais: fluxosArbitraisReducer,
  fluxoEditor: fluxoEditorReducer,
  modelosDocumento: modelosDocumentoReducer,
  modelosDecurso: modelosDecursoReducer,
  modelosAndamento: modelosAndamentoReducer,
  tiposPrazo: tiposPrazoReducer,
  modelosComunicacao: modelosComunicacaoReducer,
  modelosCarta: modelosCartaReducer,
  modelosNotificacao: modelosNotificacaoReducer,
  pesquisaSatisfacao: pesquisaSatisfacaoReducer,
});

const rootReducer = (state: ReturnType<typeof appReducers> | undefined, action: AnyAction) => {
  if (action.type === 'auth/logout/fulfilled') {
    return appReducers(undefined, action);
  }
  return appReducers(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          'batchNegociacao/setUploadedFile',
          'portalAdvogado/enviarProcuracao/pending',
          'portalAdvogado/enviarProcuracao/fulfilled',
          'portalAdvogado/enviarProcuracao/rejected',
          'negociacoes/uploadCsv/pending',
          'reguaCobranca/uploadLote/pending',
          'reguaCobranca/uploadLote/fulfilled',
          'reguaCobranca/uploadLote/rejected',
          'processoArbitral/wizardStep/uploadProofDocument/pending',
          'processoArbitral/wizardStep/uploadProofDocument/fulfilled',
          'processoArbitral/wizardStep/uploadProofDocument/rejected',
          'processoArbitral/wizardStep/retryProofDocument/pending',
          'processoArbitral/wizardStep/retryProofDocument/fulfilled',
          'processoArbitral/wizardStep/retryProofDocument/rejected',
          'processoArbitral/wizardStep/uploadConflictDocument/pending',
          'processoArbitral/wizardStep/uploadConflictDocument/fulfilled',
          'processoArbitral/wizardStep/uploadConflictDocument/rejected',
          'processoArbitral/wizardStep/retryConflictDocument/pending',
          'processoArbitral/wizardStep/retryConflictDocument/fulfilled',
          'processoArbitral/wizardStep/retryConflictDocument/rejected',
          'advogadoAutos/registrarAndamento/pending',
          'advogadoAutos/registrarAndamento/fulfilled',
          'advogadoAutos/registrarAndamento/rejected',
          'advogadoAutos/enviarMensagem/pending',
          'advogadoAutos/enviarMensagem/fulfilled',
          'advogadoAutos/enviarMensagem/rejected',
          'advogadoAutos/responderPendencia/pending',
          'advogadoAutos/responderPendencia/fulfilled',
          'advogadoAutos/responderPendencia/rejected',
          'arbitralDetalhes/enviarMensagemChat/pending',
          'arbitralDetalhes/enviarMensagemChat/fulfilled',
          'arbitralDetalhes/enviarMensagemChat/rejected',
          'secretariaArbitral/enviarAnexoDoProcesso/pending',
          'secretariaArbitral/enviarAnexoDoProcesso/fulfilled',
          'secretariaArbitral/enviarAnexoDoProcesso/rejected',
          'financeiroProcessoArbitral/anexarComprovante/pending',
          'financeiroProcessoArbitral/anexarComprovante/fulfilled',
          'financeiroProcessoArbitral/anexarComprovante/rejected',
          'citacaoArbitral/resolverPendencia/pending',
          'citacaoArbitral/resolverPendencia/fulfilled',
          'citacaoArbitral/resolverPendencia/rejected',
        ],
        ignoredPaths: ['negociacoes.batch.uploadedFile'],
      },
    }).concat(homeConversasMiddleware, contractsMiddleware, posthogAnalyticsMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
